import { render, staticRenderFns } from "./SendCard.vue?vue&type=template&id=fb89288a&lang=pug&"
import script from "./SendCard.vue?vue&type=script&lang=js&"
export * from "./SendCard.vue?vue&type=script&lang=js&"
import style0 from "./SendCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports